import React from 'react';

const hourOptions = Array.from(Array(24)).map((o,n)=>(
  <option key={n}>{n}</option>
));

const minuteOptions = Array.from(Array(60)).map((o,n)=>(
  <option key={n}>{n}</option>
));

export default ({onChangeHour, onChangeMinute, hour, minute, hourName, minuteName}) => {
  return (
    <div className="input-group" style={{display: 'flex'}}>
      <select className="form-control" style={{flex: '1 0'}} name={hourName} onChange={onChangeHour} value={hour}>
        {hourOptions}
      </select>
      <span style={{margin: 5}}>시 </span>
      <select className="form-control" style={{flex: '1 0'}} name={minuteName} onChange={onChangeMinute} value={minute}>
        {minuteOptions}
      </select>
      <span style={{margin: 5}}>분</span>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/common/TimeSelector.js